<template>
<div>
	<Form :label-width="110" @submit.native.prevent>
		<Row :gutter="10">
			<Col span="8">
				<FormItem label="参保公司">
					<Input v-model="params.companyName" clearable @on-enter="search" placeholder="参保公司名称"></Input>
				</FormItem>
			</Col>
			<Col span="16" class="right">
				<Button type="info" @click="search">搜索</Button>
				<Button type="primary" @click="excel">导出</Button>
			</Col>
		</Row>
	</Form>
	<i-table :columns="columns" url="/guarantee/queryCompany.json" :params="params" ref="table" >
		<template slot-scope="{ row, index }" slot="companyAddressShow">
			<div class="ellipsis">
				<el-tooltip class="item" effect="dark" :content="row.companyAddressShow" placement="top-start">
					<span>{{row.companyAddressShow}}</span>
				</el-tooltip> 
			</div>
		</template>
		<template slot-scope="{ row, index }" slot="attachmentUrl" :tooltip="true">
			<div class="ellipsis">
				<el-tooltip class="item" effect="dark" :content="row.companyName" placement="top-start">
					<a @click="toDetail(row)" target="_blank">{{row.companyName}}</a>	 
				</el-tooltip> 
			</div>
		</template>
		<template slot-scope="{ row, index }" slot="action"> 
			<a @click="edit(row)">编辑</a>
		</template>
	</i-table>
	<!-- 详情 -->
	<Modal
		title="参保公司"
		v-model="detailVisible" 
		width="60%"
		:footer-hide="true">
		<div style="padding-left: 10px;">  
			<div class="plattit">单位信息</div>
			<el-row class="rowSty">
				<el-col :span="12">
					<el-row >
						<el-col :span="12" >
							<span style="padding-right: 6px;">公司名称:</span>{{detail.companyName}}
						</el-col> 
					</el-row>
				</el-col>
			</el-row>
			<el-row class="rowSty">
				<el-col :span="12">
					<span style="padding-right: 6px;">统一社会信用代码:</span>{{detail.organizationCode}}
				</el-col>
				<el-col :span="12">
					<el-col :span="12"> <span style="padding-right: 6px;">企业类型:</span>{{detail.companyType}}</el-col> 
				</el-col>
			</el-row>
			<el-row class="rowSty">
				<el-col :span="12">
					<span style="padding-right: 6px;">所属行业:</span>{{detail.industry}}
				</el-col>
				<el-col :span="12">
					<span style="padding-right: 6px;">单位地址:</span>{{detail.companyAddressDesc}}{{detail.detailAddress}}
				</el-col>
			</el-row> 
			<el-row class="rowSty">
				<el-col :span="12">
					<span style="padding-right: 6px;">邮政编码:</span>{{detail.postCode}} 
				</el-col>
				<el-col :span="12">
					<el-row>
						<el-col :span="12" class="oriang-box">
							<span style="padding-right: 6px;">营业执照:</span>
							<img v-if="detail.organizationUrl&&detail.organizationUrl.length>0" :src="detail.organizationUrl" alt=" " width="50px" height="50px"  @click="openOrganization">
						</el-col> 
					</el-row>
				</el-col> 
			</el-row>  
			<div class="plattit">联系人信息</div>
			<el-row class="rowSty">
				<el-col :span="12">
					<span style="padding-right: 6px;">姓名:</span>{{detail.name}}
				</el-col>
				<el-col :span="12">
					<span style="padding-right: 6px;">电话:</span>{{detail.phone}} 
				</el-col>
			</el-row>  
			<el-row  class="rowSty">
				<el-col :span="12">
					<span style="padding-right: 6px;">邮箱:</span>{{detail.email}}
					 
				</el-col> 
			</el-row>   
		</div>
	</Modal>
	 <!-- 编辑  -->
	 <Modal
		title="编辑参保公司"
		v-model="editliberationVisible" 
		width="60%">
		<div>
			<Form  :model="editliberationData" :rules="editliberationRules" ref="editliberationData" :label-width="150" class="demo-platformData">
				<div class="plattit">单位信息</div>
				<el-row>
					<el-col :span="12">
						<FormItem label="公司名称" prop="companyName">
							<Input v-model="editliberationData.companyName" :disabled="true"  placeholder="请输入" :maxlength="20"></Input>
						</FormItem>
					</el-col> 
					<el-col :span="12">
						<FormItem label="所属平台" prop="platformName">
							<Select placeholder="请选择所属平台" v-model="editliberationData.platformName">
								<Option value="JIN_KONG">金控平台</Option>
								<Option value="U_HOME">优家平台</Option>
							</Select>
						</FormItem>
					</el-col> 
				</el-row>
				<el-row>
					<el-col :span="12">
						<FormItem label="统一社会信用代码" prop="organizationCode">
							<Input v-model="editliberationData.organizationCode"  placeholder="请输入"   :maxlength="18"></Input>
						</FormItem>
					</el-col>
					
					<el-col :span="12">
						<FormItem label="企业类型" prop="companyType">
							<Select v-model="editliberationData.companyType"  placeholder="请选择"  v-if="componyType&&componyType.length>0">
								<Option :value="item" v-for="(item,index) in componyType"  :key="index">{{item}}</Option> 
							</Select>
						</FormItem>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<FormItem label="所属行业" prop="industry"> 
							<Select v-model="editliberationData.industry"  placeholder="请选择"  v-if="industry&&industry.length>0">
								<Option :value="item" v-for="(item,index) in industry"  :key="index">{{item}}</Option> 
							</Select>
						</FormItem>
					</el-col>
					<el-col :span="12">
						<FormItem label="单位地址" prop="companyAddress">
							<Area :isRenbao="true" v-if="editAddressShow" v-model="editliberationData.companyAddress" placeholder="请选择地区" @get-city-str="areaChange" style="width:100%" />
						</FormItem>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<FormItem label="邮政编码" prop="postCode">
							<Input v-model="editliberationData.postCode" placeholder="请输入" :maxlength="6"></Input>
						</FormItem>
					</el-col>
					
					<el-col :span="12">
						<FormItem label="" prop="detailAddress">
							<Input v-model="editliberationData.detailAddress" placeholder="请输入详细地址" :maxlength="30"></Input>
						</FormItem>
					</el-col>
				</el-row> 
				<div style="color: #717276;padding-left: 150px;">请上传10M以内jpg/jpeg格式图片	</div> 
				<el-row>
					<el-col :span="12">
						<FormItem label="营业执照" prop="organizationUrl">
							<div style="display: flex;">
								<div class="demo-upload-list" v-if="editliberationData.organizationUrl.length>0">
									<template >
										<img :src="editliberationData.organizationUrl">
										<div class="demo-upload-list-cover">
											<Icon type="ios-eye-outline" @click.native="handleView()"></Icon>
											<Icon type="ios-trash-outline" @click.native="handleRemove"></Icon>
										</div>
									</template> 
								</div>
								<Upload
									ref="upload"
									:show-upload-list="false"
									:default-file-list="defaultList"
									:before-upload="beforeUp"
									:on-success="handleSuccess"
									:format="['jpg','jpeg']"  
									action="/pc/fileServer/uploadImageReturnThumbnail"
								>
									<div class="cameraBox" style="width: 58px;height:58px;line-height: 58px;border: 1px solid #eee;">
										<Icon type="ios-camera" size="20"></Icon>
									</div>
								</Upload>
							</div>  
						</FormItem>
					</el-col>
				</el-row>
				<div class="plattit">联系人信息</div>
				<el-row>
					<el-col :span="12">
						<FormItem label="姓名" prop="name">
							<Input v-model="editliberationData.name"  placeholder="请输入"   :disabled="true"></Input>
						</FormItem>
					</el-col>
					<el-col :span="12">
						<FormItem label="电话" prop="phone">
							<Input v-model="editliberationData.phone"  placeholder="请输入"  :disabled="true"></Input>
						</FormItem>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<FormItem label="邮箱" prop="email">
							<Input v-model="editliberationData.email"  placeholder="请输入"  :disabled="true"></Input>
						</FormItem>
					</el-col> 
				</el-row>
			</Form>      
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="editliberationVisible=false">取 消</el-button>
			<el-button type="primary" @click="confirmCompony" :loading="editliberationData.loading">确 定</el-button>
		</span>
	</Modal>
</div>
</template>

<script>
import ITable from '@/components/common/ITable'
import Area from '@/pages/haierProduct/components/common/Area'

export default {
	components:{ITable,Area},
	data () {
		const urlValidator=(rule, value, callback)=>{ 
            if (value === '') {
                callback(new Error('请上传营业执照'));
            }else {
                callback();
            } 
        }
		const organizationV=(rule, value, callback)=>{
			if (value&&value.length!=18) {
				callback(new Error('请输入正确的统一社会信用代码'));
			}  else {
				callback();
			} 
		}
		return {
			params:{
				productCode:'JIN_KONG'
			},
			columns:[ 
				{title: '公司名称',slot: 'attachmentUrl',width:200,tooltip:true,fixed:'left'},
				{title: '参保机构',key: 'deptName',width:200,tooltip:true},
				{title: '所属平台',key: 'platformNameShow',minWidth:200}, 
				{title: '统一社会信用代码',key: 'organizationCode',minWidth:220},
				{title: '企业类型',key: 'companyType',minWidth:130},
				{title: '所属行业',key: 'industry',minWidth:130},
				{title: '单位地址',slot: 'companyAddressShow',minWidth:130},
				{title: '邮政编码',key: 'postCode',width:120},
				{title: '联系人',key: 'name',minWidth:130},
				{title: '联系电话',key: 'phone',minWidth:130},
				{title: '联系人邮箱',key: 'email',minWidth:180},
				{title: '数据完整性',key: 'dataIntegrityShow',minWidth:200},
				{title: '操作',slot: 'action',width:80,fixed:'right'}

			],
			total:'',
			detailVisible:false,
			editliberationVisible:false,
			editliberationData:{
				organizationUrl:''
			},
			editliberationRules:{
				organizationCode:[ { required: true,validator:organizationV, trigger: 'blur' }],
				companyType:[ { required: true, message: '请选择企业类型', trigger: 'change' }],
				industry:[ { required: true, message: '请选择所属行业', trigger: 'change' }],
				companyAddress:[ { required: true, message: '请选择单位地址', trigger: 'change' }],
				postCode:[ { required: true, message: '请输入邮政编码', trigger: 'blur' }],
				detailAddress:[ { required: true, message: '请输入详细地址', trigger: 'blur' }],
				organizationUrl:[ { required: true,validator:urlValidator, trigger: 'change' }],
				platformName:[ { required: true, message: '请选择所属平台', trigger: 'change' }],
			},
			detail:{},
			defaultList:[],
			componyType:[],//公司类型
            industry:[],   //所属行业
			editAddressShow:false
		}
	},
	created () {
		this.getTypes()
	},
	methods: {
		confirmCompony(){
			this.$refs.editliberationData.validate(valid=>{
                    if(valid){
                        this.editliberationData.loading=true
                        this.$refs.editliberationData.validate(valid=>{
                            if(valid){
                                let url=''
                                let obj={}  
                                this.$axios.post('/guarantee/editCompanyUser.json',this.editliberationData).then(res=>{
                                    this.toast('保存成功')
                                    this.editliberationData.loading=false
                                    this.editliberationVisible=false
                                    this.$refs.table.getList()
                                }).catch(err=>{
                                    this.editliberationData.loading=false
                                })
                            }
                        })
                    } 
                })
		}, 
		edit(row){
			this.editAddressShow=false
			this.$set(this.editliberationData,'companyAddress', '') 
			this.title='编辑参保公司'
			this.$refs.editliberationData.resetFields()
			this.editliberationData = {
				...row,
				id: row.companyUserId
			}
			this.$set(this.editliberationData,'companyAddress',row.companyAddress ) 

			console.log('this.editliberationData',this.editliberationData)
			this.$set(this.editliberationData,'organizationUrl',row.organizationUrl?row.organizationUrl:'' ) 
			this.editliberationVisible = true;
			this.$nextTick(()=>{
				this.editAddressShow=true
			})

		},
		handleSuccess(val){
			this.$set(this.editliberationData,'organizationUrl',val.data)
		},
		beforeUp(val){ 
			if(val.type!='image/jpeg'){
				this.toast('请上传jpg/jpeg格式营业执照','error')
				return false
			}
			if(val.size > Number(10)*1024*1024) {
				this.alert('请上传10M以内jpg/jpeg格式图片');
				return false
			}
		},
		// 获取企业类型
        async getTypes () { 
            const res = await this.$axios.get("/haierEmpSettlementCompany/getCommonDropDown",{
                type:'COMPANY_TYPE'
            })
            const res_ = await this.$axios.get("/haierEmpSettlementCompany/getCommonDropDown",{
                type:'INDUSTRY'
            })
            this.componyType=res
            this.industry=res_
        },
		 // 查看营业执照
		handleView () {
			window.open(this.editliberationData.organizationUrl)
		},
		// 查看营业执照
		openOrganization(){
			window.open(this.detail.organizationUrl)
		},
		areaChange(val){ 
			this.editliberationData.companyAddressDesc=''
			val.forEach(i => {
				this.editliberationData.companyAddressDesc+=i.label
			}) 
		},
		toDetail(obj){
			this.detail=obj
            this.detailVisible=true
		},
		handleRemove (file) {
            const fileList = this.$refs.upload.fileList;
            this.editliberationData.organizationUrl=''
            this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
        }, 
		search () {
			this.$refs.table.getList();
		},
		excel () {
			this.exportToExcel("/guarantee/exportCompany",this.params);
		},
	}
}
</script>

<style scoped>
	.ellipsis {
		overflow: hidden; 
		white-space: nowrap;  
		text-overflow: ellipsis;  
	}
	.plattit{
        font-weight: 600;
        padding-bottom: 10px;
    }
	.rowSty{
        padding-left: 20px;
        padding-bottom: 15px;
    }
	.cameraBox{
        display: flex;
        align-items: center;
        justify-content: center;
    }
	.demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
	.oriang-box{
		display: flex;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/jinkong/list/Company.vue